<template>

  <div style="padding-bottom: 20px;">

	<v-row class="icoev-header-row fixNotchMarginTop fixNotchPaddingBottom">
			<v-col cols="12" class="icoev-header-title">
				<h4>
					<v-icon color="primary" style="top: -2px;">mdi-dots-vertical</v-icon>
					Más ICOEV
				</h4>
      </v-col>
    </v-row>

    <div class="icoev-main-content-wrapper fixNotchMarginTop fixNotchPaddingBottom" >

		<v-card
			outlined
			class="mx-auto"
			max-width="95%"
			style="margin-top: 16px;">
			<v-card-text style="padding: 0;">
				<v-list style="padding: 0;">
            <div v-for="link in links" :key="link.id">
              <v-list-item @click="openUrl(link)">
								<v-list-item-content>
									<v-list-item-title style="white-space: normal; font-size: 14px;">{{ link.title }}</v-list-item-title>
								</v-list-item-content>
								<v-list-item-action>
									<v-icon color="primary">mdi-open-in-new</v-icon>
								</v-list-item-action>
							</v-list-item>
              <!--<v-divider v-if="link.id != links[links.length-1].id"/>-->
              <v-divider/>
						</div>
						<v-list-item v-if="$store.state.icoev.device.platform != 'browser'">
							<v-list-item-content>
								<v-list-item-title style="white-space: normal; font-size: 14px;">Recibir notificaciones push</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-switch v-model="allowNotifications" @change="enableDevicePushNotification()"/>
							</v-list-item-action>
						</v-list-item>
            <v-divider v-if="$store.state.icoev.device.platform != 'browser'"/>
						<v-list-item @click="logout()">
							<v-list-item-content>
								<v-list-item-title style="white-space: normal; font-size: 14px;">Cerrar sesión</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action>
								<v-icon color="primary">mdi-exit-to-app</v-icon>
							</v-list-item-action>
						</v-list-item>
        </v-list>
			</v-card-text>
		</v-card>

    </div>
	</div>

</template>

<script>
import api from "../../../api/icoev";
import cordova from "../../../api/cordova";
import discovery from '../../../discovery';

export default {
  name: 'MasMain',
	data () {
		return {
			links: [
				{ id: 1, title: 'Receta privada papel', url: 'https://www.icoev.es/servicios-para-colegiados/recetadentistas/' },
				{ id: 2, title: 'Plataforma receta digital', url: 'https://www.icoev.es/chipcard_recetas/' },
				{ id: 3, title: 'Bazar', url: 'https://www.icoev.es/lst_borsatreball/borsa_llistat.php?ANUN=MATE&lang=es' },
				{ id: 4, title: 'Software y apps', url: 'https://www.icoev.es/servicios-para-colegiados/software-y-apps/' },
				{ id: 5, title: 'Cuota Cero y bonificación bajas', url: 'https://www.icoev.es/servicios-para-colegiados/rido_tramites-colegiales/solicitud_cuota_cero/' },
				{ id: 6, title: 'Revista ORIS', url: 'https://www.icoev.es/el-colegio-informa/rido_revista-oris/' },
				//{ id: 7, title: 'Congresos', url: 'https://www.icoev.es/calendar/cat_ids~28/' },
				{ id: 7, title: 'EL ABC de las clínicas', url: 'https://www.icoev.es/el-colegio-informa/documentacion/rido_abc-de-la-clinica/' },
				{ id: 8, title: 'Actualización registro sanitario', url: 'https://www.icoev.es/el-colegio-informa/documentacion/rido_actualizacion-de-datos-sanidad/' },
				{ id: 9, title: 'Apertura de clínicas', url: 'https://www.icoev.es/documentacion/apertura-de-clinicas-dentales/' },
				{ id: 10, title: 'Convenios profesionales', url: 'https://www.icoev.es/servicios-para-colegiados/convenios/rido_c_profesionales/' },
				{ id: 11, title: 'Convenios ocio', url: 'https://www.icoev.es/servicios-para-colegiados/convenios/rido_convenios_ocio_bienestar/' },
			],
			allowNotifications: false,
		}
	},
	mounted() {
	},
	methods: {
		openUrl(item) {
			if (this.$store.state.icoev.device.platform == 'browser') {
				window.open(this.getRedirectUrl(item.url));
				return;
			}

			if (this.$store.state.icoev.device.platform == 'android') {
				cordova.openUrl(encodeURI(this.getRedirectUrl(item.url)));
			} else {
				this.$emit('open-external-content', item.title, this.getRedirectUrl(item.url));
			}
		},
		/*openUrl(item) {
			this.$emit('open-external-content', item.title, this.getRedirectUrl(item.url));
		},*/
		getRedirectUrl(target) {
			return discovery.icoev_service_url+"users/redirect/"+this.$store.state.icoev.redirectToken+"?t="+target;
		},
		enableDevicePushNotification: function() {
			this.$store.commit('icoev/setDeviceAllowNotifications', this.allowNotifications);

			api.enableDevicePushNotification(this.$store.state.icoev.device);
		},
		logout: function() {
			this.$store.commit('icoev/setUser', null);
      this.$store.commit('icoev/setRedirectToken', null);

			if (this.$store.state.icoev.device.platform == 'browser') {
				window.localStorage.removeItem("icoev-login-info");
			} else {
				cordova.removeLocalStorageItem('login-info');
			}

			cordova.cancelProcessNotifications();

			this.$router.push({ name: 'login' });
		},
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.allowNotifications = vm.$store.state.icoev.device.allowNotifications;
		})
	},
}
</script>

<style scoped>
  .media-object {
    width: 128px;
    padding: 10px;
  }

  .media {
    border-top: 1px solid lightgrey;
    padding-top: 20px;
    list-style-type: none;
  }
</style>